import * as TypeGraphQL from "type-graphql";
export var SignalGeneratorMetricsScalarFieldEnum;
(function (SignalGeneratorMetricsScalarFieldEnum) {
    SignalGeneratorMetricsScalarFieldEnum["id"] = "id";
    SignalGeneratorMetricsScalarFieldEnum["timestamp"] = "timestamp";
    SignalGeneratorMetricsScalarFieldEnum["generatorSource"] = "generatorSource";
    SignalGeneratorMetricsScalarFieldEnum["symbol"] = "symbol";
    SignalGeneratorMetricsScalarFieldEnum["totalSignals"] = "totalSignals";
    SignalGeneratorMetricsScalarFieldEnum["successfulSignals"] = "successfulSignals";
    SignalGeneratorMetricsScalarFieldEnum["failedSignals"] = "failedSignals";
    SignalGeneratorMetricsScalarFieldEnum["winRate"] = "winRate";
    SignalGeneratorMetricsScalarFieldEnum["sharpeRatio"] = "sharpeRatio";
    SignalGeneratorMetricsScalarFieldEnum["profitFactor"] = "profitFactor";
    SignalGeneratorMetricsScalarFieldEnum["averageReturn"] = "averageReturn";
    SignalGeneratorMetricsScalarFieldEnum["maxDrawdown"] = "maxDrawdown";
    SignalGeneratorMetricsScalarFieldEnum["averageTimeToProfit"] = "averageTimeToProfit";
    SignalGeneratorMetricsScalarFieldEnum["calibrationAccuracy"] = "calibrationAccuracy";
    SignalGeneratorMetricsScalarFieldEnum["performanceTrend"] = "performanceTrend";
    SignalGeneratorMetricsScalarFieldEnum["lookbackPeriodDays"] = "lookbackPeriodDays";
    SignalGeneratorMetricsScalarFieldEnum["healthScore"] = "healthScore";
    SignalGeneratorMetricsScalarFieldEnum["healthStatus"] = "healthStatus";
    SignalGeneratorMetricsScalarFieldEnum["healthIssues"] = "healthIssues";
    SignalGeneratorMetricsScalarFieldEnum["updatedAt"] = "updatedAt";
})(SignalGeneratorMetricsScalarFieldEnum || (SignalGeneratorMetricsScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(SignalGeneratorMetricsScalarFieldEnum, {
    name: "SignalGeneratorMetricsScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=SignalGeneratorMetricsScalarFieldEnum.js.map